module.exports = __FOREMAN_VENDOR__RC_INPUT_NUMBER__;